<template>
  <div class="d-flex justify-content-start" v-click-outside="clickOutside">
    <div
      class="position-relative d-flex justify-content-center align-items-center color-show  border rounded"
      :style="{ backgroundColor: formColor, height: '30px', width: '35px' }"
    >
      <div
        v-if="showColorPicker"
        class="position-absolute color-picker-container"
        style="z-index: 3;"
      >
        <twitter-picker
          v-model="formColor"
          triangle="top-left"
          :defaultColors="defaultColors"
        />
      </div>
      <span
        v-if="formColor === '#ffffff' || formColor === 'white'"
        style="font-size: 10px;"
        >None</span
      >
    </div>
    <div class="ml-2">
      <i
        @click="showColorPicker = !showColorPicker"
        class="fa fa-edit text-success cursor-pointer"
        style="font-size:15px;"
      ></i>
      <i
        v-if="formColor !== '#ffffff'"
        @click="$emit('removeColor')"
        class="fa fa-close text-danger cursor-pointer"
        style="font-size:15px;"
      ></i>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Twitter as TwitterPicker } from "vue-color";

export default defineComponent({
  name: "ServiceColorPicker",
  components: { TwitterPicker },
  props: ["value"],
  data() {
    return {
      showColorPicker: false,
      defaultColors: [
        "#F44E3B",
        "#FE9200",
        "#FCDC00",
        "#DBDF00",
        "#A4DD00",
        "#68CCCA",
        "#73D8FF",
        "#AEA1FF",
        "#FDA1FF",
        "#808080",
        "#CCCCCC",
        "#D33115",
        "#E27300",
        "#FCC400",
        "#B0BC00",
        "#68BC00",
        "#16A5A5",
        "#009CE0",
        "#7B64FF",
        "#FA28FF",
        "#000000",
        "#B3B3B3",
        "#9F0500",
        "#C45100",
        "#FB9E00",
        "#808900",
        "#194D33",
        "#0C797D",
        "#0062B1",
        "#653294",
        "#AB149E"
      ]
    };
  },
  methods: {
    clickOutside() {
      this.showColorPicker = false;
    },
    clearColor() {
      this.$emit("removeColor");
      this.showColorPicker = false;
    }
  },
  computed: {
    formColor: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (newValue && newValue.hex) this.$emit("input", newValue.hex);
        this.showColorPicker = false;
      }
    }
  }
});
</script>

<style scoped>
.color-picker-container {
  left: 0;
  top: 38px;
}
</style>
